// SETTINGS V2 — Služba page time helpers — SETTINGS_V2_SP8 §2.
// Ported VERBATIM from the legacy SettingsService.tsx (formatTimeSpan lines
// 65-75, toTimeSpan lines 127-130). Byte-identical logic: the .NET TimeSpan
// wire format ("16:00:00", or day-prefixed "1.16:00:00") ↔ the plain "HH:mm"
// input string. Pure functions, no React.

/** ".NET TimeSpan → "HH:mm"". Handles a leading day component ("1.16:00:00"). */
export const formatTimeSpan = (ts: string | null | undefined): string => {
  if (!ts) return "";
  // TimeSpan from .NET can be "16:00:00" or "1.16:00:00" (with days)
  const parts = ts.split(":");
  if (parts.length >= 2) {
    // Handle day prefix like "1.16"
    const hourPart = parts[0].includes(".") ? parts[0].split(".")[1] : parts[0];
    return `${hourPart.padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
  }
  return "";
};

/** ""HH:mm" → "HH:mm:00"" (.NET TimeSpan); empty string → null. */
export const toTimeSpan = (time: string): string | null => {
  if (!time) return null;
  return `${time}:00`;
};
